import { signalStore } from '@ngrx/signals';
import { withProjectJourney } from './project-journey.store.feature';
import { environment } from '@environment';

export const withTreeShakableDevTools = environment.storeWithDevTools;

export const ProjectJourneyStore = signalStore(
  { providedIn: 'root' },
  withTreeShakableDevTools('admin-project-journey'),
  withProjectJourney(),
);
